import type { Step } from "react-joyride";

const kemTourSteps: Step[] = [
  {
    target: ".kem-tour-header",
    content:
      "Welcome to Kem 2.0\nIn this tour, you will learn how to use all the new features in Kem - your AI health coach chatbot.",
    placement: "bottom",
    buttons: ["close", "primary"],
    skipBeacon: true,
  },
  {
    target: ".kem-tour-text-input",
    content:
      'Get started with Kem by typing a message here, like; "How can I control my blood pressure?"',
    placement: "top",
    skipBeacon: true,
  },
  {
    target: ".kem-tour-send-button",
    content: "When you are done, press the send button",
    placement: "top",
    skipBeacon: true,
  },
  {
    target: ".kem-tour-voice-button",
    content:
      "You can also send a message using the voice command, simply tap and speak.\nWhen done, press the send button.",
    placement: "top",
    skipBeacon: true,
  },
  {
    target: ".kem-tour-talk-to-kem",
    content:
      'Want to have a voice conversation with Kem? Click "Talk to Kem" for a hands-free experience where you can speak and hear Kem\'s responses.',
    placement: "bottom",
    skipBeacon: true,
  },
  {
    target: ".kem-tour-privacy-link",
    content:
      "Our privacy policy is available here.\nWhile I'm here to provide information and support, please remember that I'm not a substitute for professional medical advice, diagnosis, or treatment. Always consult your mDoc health coach or other qualified healthcare providers. Let's chat!",
    placement: "bottom",
    skipBeacon: true,
  },
];

export default kemTourSteps;
